module.exports = function(callback) {
    if (!window.Intl) {
        require(['intl'], function(Intl) {
            //window.Intl = Intl;
            callback();
        });
    } else {
        setTimeout(callback, 0); // force async
    }
};



// WEBPACK FOOTER //
// ./src/ui/app/intlShim.js